import { ReactNode, useMemo, useState } from 'react';
import { TabsContext } from './TabsContext';

interface Props {
    defaultTabId: string;
    children: ReactNode;
}

export function TabsContextProvider({ children, defaultTabId }: Props) {
    const [activeTabId, setActiveTabId] = useState(defaultTabId);

    const value = useMemo(
        () => ({
            activeTabId,
            setActiveTabId,
        }),
        [activeTabId],
    );

    return <TabsContext.Provider value={value}>{children}</TabsContext.Provider>;
}
